<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Pessoa'"
      :label-width="labelWidth"
      :helper="helper"
      :error="error"
      :no-label="noLabel"
      :helper-position="helperPosition || 'lb'"
  >
    <erp-select
        @input="__set"
        :loading="loading"
        :placeholder="placeholder || 'Selecione'"
        :options="asyncdata"
        v-model="model"
        :multiple="multiple"
        :simpleBorder="simpleBorder"
        :size="size || '1'"
    ></erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../mixins/SelectMixin'
//import {tiposEmail as list} from '../../../../domain/pessoa/domain'

export default {
  name: 'ProdutividadePessoaSelect',
  mixins: [SelectMixin],
  props: {
    etapa: {
      required: true
    }
  },
  data () {
    return {
      asyncdata: []
    }
  },
  computed: {},
  mounted () {
    this.load()
  },
  components: {},
  methods: {
    load () {
      //this.loading = true
      this.loading = false
      if (!this.etapa.pessoas || !this.etapa.pessoas.length) {
        return
      }
      this.asyncdata = this.etapa.pessoas.map(p => {
        return {
          ...p,
          label: p.pessoa.name,
          value: p.pessoa.id
        }
      })
      /*list()
          .then((response) => {
            this.loading = false
            if (!Array.isArray(response.data.result)) {
              return
            }
            let list = response.data.result.map((obj) => {
              return {
                ...obj,
                label: obj.name,
                value: obj.id
              }
            })

            !this.multiple && !this.required && list.unshift({label: this.placeholder || 'Selecione', value: null})
            this.asyncdata = list

            if (this.selectFirst) {
              this.$nextTick(() => {
                this.__emit(list[0].value)
              })
            }
          })
          .catch((error) => {
            this.loading = false

          })*/
    }
  }
}
</script>
